import { ToggleButton } from '@heroui/react'
import { Glyph } from './Editor'
import { COUNTER_SCREENS } from './counter'
import type { CounterScreen, Screen } from './types'
import { useStaffText } from '../ui/StaffText'
import type { StaffKey } from '../lib/staffText'

const NAMES: Record<CounterScreen, { label: StaffKey; glyph: 'ticketNumber' | 'deskStatus' }> = {
  called: { label: 'designs.ed.called', glyph: 'ticketNumber' },
  free: { label: 'designs.ed.free', glyph: 'deskStatus' },
}

/** A counter display's two screens in the left panel: a ticket at the desk, or none. */
export function CounterTabs({ screen, onPick }: { screen: Screen; onPick: (screen: CounterScreen) => void }) {
  const { say } = useStaffText()
  return (
    <div className="studio-screens" role="group" aria-label={say('designs.ed.counterScreen')}>
      {COUNTER_SCREENS.map((s) => (
        <ToggleButton key={s} variant="ghost" size="sm" className="studio-navrow" isSelected={screen === s} onPress={() => onPick(s)}>
          <Glyph of={NAMES[s].glyph} size={16} />
          <span className="studio-navrow__name">{say(NAMES[s].label)}</span>
        </ToggleButton>
      ))}
    </div>
  )
}
